<app-header></app-header>

<!-- Page title section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center z-index-1">
            <h1 class="fw-bold uppercase letter-spacing-1 m-0">Portfolio Two</h1>
        </div><!-- end container -->
    </div>
</div>
<!-- end Page title section -->

<!-- Portfolio section -->
<div class="section">
  <div class="container-fluid px-4">
    <div class="row gallery-wrapper g-4 border-radius">
      <div *ngFor="let item of galleryItems; let i = index" class="col-12 col-md-6 col-lg-4 gallery-box img-class">
        <div class="gallery-img" (click)="openGallery(i)" style="cursor: pointer;">
          <img [src]="item.src" [alt]="item.title" style="width: 100%; height: 100%; object-fit: cover;">
        </div>
      </div>
    </div><!-- end row -->
  </div><!-- end container-fluid -->

<!-- Custom Lightbox Modal -->
<div *ngIf="showGalleryModal" class="gallery-modal" style="display: flex;" (click)="closeGallery()">
  <div class="gallery-modal-content" (click)="$event.stopPropagation()">
    <div class="gallery-modal-header">
      <button (click)="closeGallery()" class="gallery-modal-close">&times;</button>
    </div>
    <div class="gallery-modal-body">
      <img [src]="galleryItems[currentGalleryIndex].src" [alt]="galleryItems[currentGalleryIndex].title">
      <div class="gallery-modal-nav">
        <button (click)="previousGalleryImage()" class="gallery-nav-btn gallery-nav-prev">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="gallery-counter">{{ currentGalleryIndex + 1 }} / {{ galleryItems.length }}</span>
        <button (click)="nextGalleryImage()" class="gallery-nav-btn gallery-nav-next">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div><!-- end Custom Lightbox Modal -->

</div>
<!-- end Portfolio section -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-3.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Sliding Text -->
<section class="section-sm">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->